import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectUserLanguagePrimary } from '../../services/user/index'
import { URL_HOME } from '../../services/url/constants'
import { getEmailCustomerServiceUrl } from '../../services/url/index'
import { TYPE_LOGIN } from '../../services/dialog/index'
import { setOverlayDialogVisible } from '../../services/dialog/actions'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import Link, { TARGET_BLANK } from '../Link/index'
import ButtonSignUp, { BUTTON_SIGN_UP_TYPE_LINK } from '../ButtonSignUp/index'
import { H1, HEADING_TYPES } from '../Heading/index'
import { useTranslatedText } from '../OracleCommons/StaticTextContext'

interface OracleAccessDeniedProps {
  notMember: boolean
}

export const OracleAccessDenied: React.FC<OracleAccessDeniedProps> = ({ notMember }) => {
  const userLanguage = useSelector(selectUserLanguagePrimary)
  const emailCustomerServiceUrl = getEmailCustomerServiceUrl(userLanguage)
  const title = useTranslatedText({ keys: ['accessDenied', 'title'] })
  const description = useTranslatedText({ keys: ['accessDenied', 'description'] })
  const anonymousDescription = useTranslatedText({ keys: ['accessDenied', 'anonymousDescription'] })
  const contact = useTranslatedText({ keys: ['accessDenied', 'contact'] })
  const cta = useTranslatedText({ keys: ['accessDenied', 'cta'] })
  const signUp = useTranslatedText({ keys: ['accessDenied', 'signUp'] })
  const notGaiaMemberYet = useTranslatedText({ keys: ['accessDenied', 'notGaiaMemberYet'] })
  const memberLogin = useTranslatedText({ keys: ['accessDenied', 'memberLogin'] })

  const dispatch = useDispatch()

  const onClickLoginButton = () => {
    dispatch(setOverlayDialogVisible(TYPE_LOGIN))
  }

  if (notMember) {
    return (
      <div className="oracle-access-denied">
        <H1 as={HEADING_TYPES.H6} className="oracle-access-denied__anonymous-title">
          {anonymousDescription}
        </H1>
        <Button
          type={BUTTON_TYPES.PRIMARY}
          className="oracle-access-denied__anonymous-cta"
          onClick={onClickLoginButton}
        >
          {memberLogin}
        </Button>
        <p className="oracle-access-denied__sign-up-description">
          {`${notGaiaMemberYet}, `}
          <ButtonSignUp
            text={signUp}
            type={BUTTON_SIGN_UP_TYPE_LINK}
            buttonClass={'oracle-access-denied__sign-up-link'}
            scrollToTop
          />
          .
        </p>
      </div>
    )
  }

  return (
    <div className="oracle-access-denied">
      <H1 as={HEADING_TYPES.H4} className="oracle-access-denied__title">
        {title}
      </H1>
      <p className="oracle-access-denied__description">
        {`${description} `}
        <Link to={emailCustomerServiceUrl} target={TARGET_BLANK}>
          {`${contact}.`}
        </Link>
      </p>
      <Button
        type={BUTTON_TYPES.PRIMARY}
        className="oracle-access-denied__cta"
        url={URL_HOME}
      >
        {cta}
      </Button>
    </div>
  )
}
